export default __webpack_public_path__ + "046b616d25af43b3891a544a2517ebad.png";